import { t } from 'ttag';

const initialState = {
  loginSuccess: false,
  signupSuccess: false,
  resetSuccess: false,
  isAuth: false,
  isFetching: false,
  termsAndConditions: 'ignore',
  show_terms_and_conditions: false,
  errors: {},
  didLogout: false,
};

// error object with all the errors from backend
// depending on the code it updates the error
// console log error.data.code / error.data.message

const updateErrors = (state, action) => {
  const newErrors = { ...state.errors };
  if (action.error.errors) {
    if (Array.isArray(action.error.errors) && action.error.errors[0].detail) {
      newErrors[action.error.errors[0].status] = action.error.errors[0].detail;
    } else {
      newErrors[action.error.code] = action.error.errors;
    }
  } else {
    newErrors[action.error.code] = action.error.message;
  }
  return newErrors;
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'SIGNUP_SUCCESS':
    return {
      ...state,
      signupSuccess: action.signupSuccess,
      isFetching: false,
      errors: {},
       termsAndConditions: false,
    };
    case 'SIGNUP_FAIL': {
      return {
        ...state,
        signupSuccess: false,
        errors: updateErrors(state, action),
        isFetching: false,
      };
    }
  case 'LOGIN_SUCCESS':
    return {
      ...state,
      loginSuccess: true,
      isAuth: true,
      isFetching: false,
      errors: {},
      show_terms_and_conditions: false,
    };
  case 'LOGIN_FAIL': {
    return {
      ...state,
      loginSuccess: false,
      errors: updateErrors(state, action),
      isFetching: false,
      isAuth: false,
    };
  }
  case 'UNAUTH_USER':
    return {
      ...state,
      loginSuccess: false,
      isAuth: false,
      isFetching: false,
      error: {},
      isPosting: false,
      posted: false,
      didLogout: true,
      err: '',
    };
  case 'AUTH_SUCCESS':
    return {
      ...state,
      isAuth: true,
    };
  case 'AUTH_FAIL': {
    return {
      ...state,
      isAuth: false,
      loginSuccess: false,
      isFetching: false,
      errors: updateErrors(state, action),
    };
  }
  case 'MAKE_REQUEST':
    return {
      ...state,
      isFetching: true,
      errors: {},
    };
  case 'TOGGLE_TERMSBOX':
    return {
      ...state,
      termsAndConditions: action.value,
    };
  case 'TERMS_ERROR': {
    return {
      ...state,
      errors: updateErrors(state, { error: { code: 'terms_error', message: t`Please accept terms and conditions` } }),
    };
  }
  case 'SHOW_TERMS':
    return {
      ...state,
      show_terms_and_conditions: true,
      isFetching: false,
      errors: {},
      termsAndConditions: false,
    };
    case 'RESET_PASSWORD':
        return {
          ...state,
          isPosting: true,
        };
    case 'RESET_PASSWORD_FAILURE':
      return {
        ...state,
        resetSuccess: false,
        isPosting: false,
        errors: updateErrors(state, action),
      };
    case 'RESET_PASSWORD_SUCCESS':
      return {
        ...state,
        resetSuccess: action.resetSuccess,
        isPosting: false,
        posted: true,
      };
    case 'CHANGE_PASS':
      return {
        ...state,
        isFetching: false,
        errors: {},
      };
      case 'CHANGE_PASS_SUCCESS':
      return {
        ...state,
        resetSuccess: true,
      };
      case 'CHANGE_PASS_FAILURE':
        return {
          ...state,
          resetSuccess: false,
          isFetching: false,
          errors: updateErrors(state, action),
        };
      case 'CLEAR_FEEDBACK':
        return {
          ...state,
          signupSuccess: false,
          resetSuccess: false,
          // didLogout: false,
          errors: {},
        };
        case 'RESET':
        return {
          ...state,
          loginSuccess: false,
          signupSuccess: false,
          resetSuccess: false,
          isAuth: false,
          isFetching: false,
          termsAndConditions: 'ignore',
          show_terms_and_conditions: false,
          errors: {},
          didLogout: false,
        };
  default:
    return state;
  }
};

export default authReducer;
